module.exports = __webpack_public_path__ + "static/media/loading_image.6037a355.png";